import { ShipmentListSearchCriteria } from '../models/shipment.model';

export class ShipmentGlobalTrackingMapLoad {
  public static readonly type = '[ShipmentMap] Load';

  constructor(public searchCriteria: ShipmentListSearchCriteria, public mapThreshold: number) {}
}

export class ShipmentGlobalTrackingMapSetInitialState {
  public static readonly type = '[ShipmentMap] Set Initial State';
}
